import { render } from "./Networks.vue?vue&type=template&id=f56bf640&scoped=true"
import script from "./Networks.vue?vue&type=script&lang=js"
export * from "./Networks.vue?vue&type=script&lang=js"

import "./Networks.vue?vue&type=style&index=0&id=f56bf640&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f56bf640"]])

export default __exports__